/* eslint-disable no-restricted-globals */
import { CHECK_EMAIL_REMINDER_PARAM } from "@components/collapsible-header/CollapsibleHeader";
import { reroll, setParam } from "./utils";

export default {
  referral({ showEmailReminder }: { showEmailReminder?: boolean }) {
    const queryParams = new URLSearchParams(location.search);
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);
    reroll("/referral", queryParams);
  },
};
